import { render, staticRenderFns } from "./EditDomicilioSolcitudInfo.vue?vue&type=template&id=524069e5&scoped=true"
import script from "./EditDomicilioSolcitudInfo.vue?vue&type=script&lang=js"
export * from "./EditDomicilioSolcitudInfo.vue?vue&type=script&lang=js"
import style0 from "./EditDomicilioSolcitudInfo.vue?vue&type=style&index=0&id=524069e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524069e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VRow,VTextField})
